module.exports = __webpack_public_path__ + "img/knop-reunies.dec48c04.jpg";